import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
// import Home from '../views/Home.vue'
// import User from '../views/User.vue'
import Main from '../views/Main.vue'
// import Mall from '../views/Mall'
// import PageOne from '@/views/PageOne'
// import PageTwo from '@/views/PageTwo'
import Login from '../views/Login.vue'
import Cookies from 'js-cookie'
const routes=[
    {
        path:'/',
        component: Main,
        name:'Main',
        redirect:'/home',//重定向
        //子路由
        children:[
            // { path:'home',name:'home' , component : Home},
            // { path:'user',name:'user' ,  component : User},
            // {path:'mall',name:'mall' ,component: Mall}, //商品管理
            // {path:'page1',name:'page1' ,component: PageOne},
            // {path:'page2',name:'page2' ,component: PageTwo},
        ]
    },
    {
        path:'/login',
        name:'login',
        component:Login
    }
    
]
const router = new VueRouter({
    routes
})
//添加路由守卫
router.beforeEach((to,from,next)=>{
    //判断token是否存在
    const token = Cookies.get("token")
    if(!token && to.name!=='login'){
        next({name:'login'})
    }else if(token && to.name=='login'){
        next({name:'home'})
    }else{
        next()
    }
})


export default router